var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a0c8c12217b14d3f59a86e3ad8b9c165d2080e36"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["streamline_detail@zhuanzhuan"]={id:"a0c8c12217b14d3f59a86e3ad8b9c165d2080e36"};
      